import { Link, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { AGENCY_SUPPORT_EMAIL } from 'features/admin/constants';
import { ANFooterLogo } from 'ui-kit/icons/Logo';

const FA_BRAND_BLUE = '#013A6F';

const FOOTER_LINKS = [
  { label: 'Contact Us', href: `mailto:${AGENCY_SUPPORT_EMAIL}`, external: false },
  { label: 'Privacy Policy', href: 'https://www.firstam.com/privacy-policy/', external: true },
  { label: 'Accessibility', href: 'https://www.firstam.com/accessibility/', external: true },
  { label: 'Terms of Use', href: 'https://www.firstam.com/terms-of-use/', external: true },
];

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      maxWidth: 720,
      padding: theme.spacing(3, 2),
      textAlign: 'center',
      width: '100%',
    },
    logoContainer: {
      alignItems: 'center',
      display: 'flex',
      height: 48,
      justifyContent: 'center',
      marginBottom: theme.spacing(4),
      /* The shared SVG has no viewBox, so it can only be resized by transform */
      '& svg': {
        transform: 'scale(1.2)',
      },
    },
    links: {
      columnGap: theme.spacing(2),
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      marginBottom: theme.spacing(1),
      rowGap: theme.spacing(1),
    },
    link: {
      color: FA_BRAND_BLUE,
      textDecorationColor: FA_BRAND_BLUE,
      '&:hover': {
        color: 'rgba(1, 58, 111, 0.8)',
      },
    },
    disclaimer: {
      color: FA_BRAND_BLUE,
      display: 'block',
      marginBottom: theme.spacing(0.5),
    },
  }),
);

const TitleMonitoringFooter = (): JSX.Element => {
  const classes = useStyles();

  return (
    <footer className={classes.footer}>
      <div className={classes.logoContainer} data-testid="titleMonitoringFooterLogo">
        <ANFooterLogo />
      </div>
      <div className={classes.links}>
        {FOOTER_LINKS.map(({ label, href, external }) => (
          <Link
            key={label}
            href={href}
            variant="body2"
            underline="always"
            className={classes.link}
            {...(external ? { target: '_blank', rel: 'noreferrer' } : {})}
          >
            {label}
          </Link>
        ))}
      </div>
      <Typography variant="body2" className={classes.disclaimer}>
        ©{new Date().getFullYear()} First American Financial Corporation and/or its affiliates. All rights reserved.
      </Typography>
      <Typography variant="body2" className={classes.disclaimer}>
        First American Title Insurance Company, and the operating divisions thereof, make no express or implied warranty
        respecting the information presented and assumes no responsibility for errors or omissions.
      </Typography>
    </footer>
  );
};

export default TitleMonitoringFooter;
